@if (configuration()) { @switch (configuration().type) { @case
(SimpleFilterType.TEXT) {
<div class="search">
  <wm-front-input
    #input
    iconLeft="search-sm"
    [placeholder]="
      configuration().display!.placeholder || configuration().display!.label
    "
    [fastDelete]="true"
    [ngModel]="valueHolder()"
    [disabled]="!!configuration().disabled"
    [class]="configuration()?.classes"
    (focusEvent)="onTextFocus()"
    (blurEvent)="onTextBlur()"
    (ngModelChange)="valueHolder.set($event); handleSearch()"
  >
  </wm-front-input>
  @if (helpersAreOpen()) {
  <div class="menu-container">
    @for (opt of helpers(); track opt.value) {
    <button
      class="button"
      mat-menu-item
      (mousedown)="$event.preventDefault()"
      (click)="onHelperSelected(opt.value)"
    >
      {{ opt.value }}
      <span class="description">{{ opt.description }}</span>
    </button>
    }
  </div>
  }
</div>
} @case (SimpleFilterType.DROPDOWN) {
<div>
  <button
    #dropdownButton
    wm-front-button
    status="transparent"
    [outline]="true"
    [flat]="true"
    [class.checked]="valueHolderAsArray()?.length"
    [disabled]="configuration().disabled"
    (click)="openDropdownAndFetchData()"
  >
    @if (isResponsive() && isOpen()) {
    <mat-icon class="arrow-responsive-back" svgIcon="arrow-right-sm">
    </mat-icon>
    }
    <span>{{ configuration().display!.label }}</span>
    @if (valueHolderAsArray()?.length) {
    <span class="count"> {{ valueHolderAsArray()?.length }}</span>
    } @if (!valueHolderAsArray()?.length && valueHolderAsArray()?.length !== 0
    && valueHolder() !== undefined) {
    <span class="count">1</span>
    } @if (!isResponsive() || !isOpen()) {
    <mat-icon svgIcon="reduce-xs" [class.open]="isOpen()"></mat-icon>
    }
  </button>
  @if (isOpen() && configuration().data?.length) {
  <wm-front-autocomplete-dropdown
    #dropdownElement
    [class.align-right]="alignsRight()"
    [class.display-inline]="displayListInline()"
    [options]="options"
    [activeResetBtn]="
      !!valueHolderAsArray()?.length || !!isRadioButtonModeAndAsValue()
    "
    [hideSearch]="!!configuration().withoutSearch"
    [placeholder]="configuration().display!.placeholder"
    [emptySearchMessage]="configuration().display!.emptyResult"
    [radioMode]="!!configuration().radioButtonMode"
    [disabled]="!!configuration().disabled"
    [hideResetBtn]="displayListInline()"
    (queryChanged)="handleQueryChanged($event)"
    (valuePicked)="handleOptionPicked($event)"
    (shouldClose)="closeAutocompletePanel()"
    (reseted)="handleResetOptionsSelected()"
  >
  </wm-front-autocomplete-dropdown>
  } @if (isOpen() && !!configuration().dataGetter) {
  <wm-front-autocomplete-dropdown
    [class.align-right]="alignsRight()"
    [class.display-inline]="displayListInline()"
    [options]="options"
    [hideSearch]="!!configuration().withoutSearch"
    [error]="!!(state.error$(configuration().key!) | async)"
    [loading]="!!(state.loading$(configuration().key!) | async)"
    [activeResetBtn]="
      !!valueHolderAsArray()?.length || !!isRadioButtonModeAndAsValue()
    "
    [placeholder]="configuration().display!.placeholder"
    [emptySearchMessage]="configuration().display!.emptyResult"
    [backendFiltering]="!configuration().withoutBackendFiltering"
    [disabled]="!!configuration().disabled"
    [hideResetBtn]="displayListInline()"
    [minSearchLength]="minSearchLength()"
    (queryChanged)="handleQueryChanged($event)"
    (scrolled)="handleInfiniteScroll()"
    (valuePicked)="handleOptionPicked($event)"
    (shouldClose)="closeAutocompletePanel()"
    (reseted)="handleResetOptionsSelected()"
  >
  </wm-front-autocomplete-dropdown>
  }
</div>
} @case (SimpleFilterType.PERIOD) {
<div>
  <button
    wm-front-button
    status="transparent"
    [outline]="true"
    [flat]="true"
    [class.checked]="valueHolderAsArray()?.length"
    [disabled]="configuration().disabled"
    (click)="openDropdownAndFetchData()"
  >
    @if (isResponsive() && isOpen()) {
    <mat-icon class="arrow-responsive-back" svgIcon="arrow-right-sm">
    </mat-icon>
    }
    <span>{{ configuration().display!.label }}</span>
    @if (valueHolderAsArray()?.length) {
    <span class="count"> {{ valueHolderAsArray()?.length }}</span>
    } @if (!valueHolderAsArray()?.length && valueHolderAsArray()?.length !== 0
    && valueHolder() !== undefined) {
    <span class="count">1</span>
    } @if (!isResponsive() || !isOpen()) {
    <mat-icon svgIcon="calendar-sm" class="calendar-icon"></mat-icon>
    }
  </button>
  @if (isOpen()) {
  <wm-front-date-range-picker
    [period]="valueHolderAsDateFilter()"
    (valueChanged)="handlePeriodPicked($event)"
    (shouldClose)="closeAutocompletePanel()"
    (reseted)="onPeriodFilterReset()"
  ></wm-front-date-range-picker>
  }
</div>
} @case (SimpleFilterType.TOGGLE) {
<wm-front-toggle
  [options]="configuration().data || []"
  [ngModel]="valueHolderAsSoleValue()"
  (ngModelChange)="handleOptionPicked({ value: $event })"
></wm-front-toggle>
} } }
